import { i18n } from '@fs/zion-locale'

/**
 * Rules for BCP-47 code
 * lang - 2 or 3 chars, MUST be in a registry
 * region - 2 letters or 3-4 digits, MUST be in registry
 * script - 4 letters (first is capitalized by convention), MUST be in registry
 * ext - language extension (like jyutping or wadegile), specific to a lang, MUST be in a registry
 *
 * std-ws-core API could be used to verify locale (e.g. /core/locales/{localeStr})
 *
 */
// Future TODO: consider using cv backend to replace with API call
export function getLanguages() {
  return [
    { key: 'abq', primaryText: i18n.t('language-suggest.abq-language.text', 'Abaza') },
    { key: 'ab', primaryText: i18n.t('language-suggest.ab-language.text', 'Abkhazian') },
    { key: 'aa', primaryText: i18n.t('language-suggest.aa-language.text', 'Afar') },
    { key: 'af', primaryText: i18n.t('language-suggest.af-language.text', 'Afrikaans') },
    { key: 'ak', primaryText: i18n.t('language-suggest.ak-language.text', 'Akan') },
    { key: 'sq', primaryText: i18n.t('language-suggest.sq-language.text', 'Albanian') },
    { key: 'sqj', primaryText: i18n.t('language-suggest.sqj-language.text', 'Albanian languages') },
    { key: 'tut', primaryText: i18n.t('language-suggest.tut-language.text', 'Altaic languages') },
    { key: 'am', primaryText: i18n.t('language-suggest.am-language.text', 'Amharic') },
    { key: 'ar', primaryText: i18n.t('language-suggest.ar-language.text', 'Arabic') },
    { key: 'an', primaryText: i18n.t('language-suggest.an-language.text', 'Aragonese') },
    { key: 'hy', primaryText: i18n.t('language-suggest.hy-language.text', 'Armenian') },
    { key: 'as', primaryText: i18n.t('language-suggest.as-language.text', 'Assamese') },
    { key: 'av', primaryText: i18n.t('language-suggest.av-language.text', 'Avaric') },
    { key: 'ae', primaryText: i18n.t('language-suggest.ae-language.text', 'Avestan') },
    { key: 'ay', primaryText: i18n.t('language-suggest.ay-language.text', 'Aymara') },
    { key: 'az', primaryText: i18n.t('language-suggest.az-language.text', 'Azerbaijani') },
    { key: 'bm', primaryText: i18n.t('language-suggest.bm-language.text', 'Bambara') },
    { key: 'ba', primaryText: i18n.t('language-suggest.ba-language.text', 'Bashkir') },
    { key: 'eu', primaryText: i18n.t('language-suggest.eu-language.text', 'Basque') },
    { key: 'be', primaryText: i18n.t('language-suggest.be-language.text', 'Belarusian') },
    { key: 'bn', primaryText: i18n.t('language-suggest.bn-language.text', 'Bengali') },
    { key: 'bh', primaryText: i18n.t('language-suggest.bh-language.text', 'Bihari languages') },
    { key: 'bik', primaryText: i18n.t('language-suggest.bik-language.text', 'Bikol') },
    { key: 'bi', primaryText: i18n.t('language-suggest.bi-language.text', 'Bislama') },
    { key: 'bs', primaryText: i18n.t('language-suggest.bs-language.text', 'Bosnian') },
    { key: 'br', primaryText: i18n.t('language-suggest.br-language.text', 'Breton') },
    { key: 'bg', primaryText: i18n.t('language-suggest.bg-language.text', 'Bulgarian') },
    { key: 'my', primaryText: i18n.t('language-suggest.my-language.text', 'Burmese') },
    { key: 'zh-yue', primaryText: i18n.t('language-suggest.zh-yue-language.text', 'Cantonese Chinese') },
    { key: 'ca', primaryText: i18n.t('language-suggest.ca-language.text', 'Catalan; Valencian') },
    { key: 'cau', primaryText: i18n.t('language-suggest.cau-language.text', 'Caucasian languages') },
    { key: 'ceb', primaryText: i18n.t('language-suggest.ceb-language.text', 'Cebuano') },
    { key: 'km', primaryText: i18n.t('language-suggest.km-language.text', 'Central Khmer') },
    { key: 'ch', primaryText: i18n.t('language-suggest.ch-language.text', 'Chamorro') },
    { key: 'ce', primaryText: i18n.t('language-suggest.ce-language.text', 'Chechen') },
    { key: 'ny', primaryText: i18n.t('language-suggest.ny-language.text', 'Chichewa; Chewa; Nyanja') },
    { key: 'zh', primaryText: i18n.t('language-suggest.zh-language.text', 'Chinese') },
    { key: 'zh-hans', primaryText: i18n.t('language-suggest.zh-hans-language.text', 'Chinese(Simplified)') },
    { key: 'zh-hant', primaryText: i18n.t('language-suggest.zh-hant-language.text', 'Chinese(Traditional)') },
    {
      key: 'cu',
      primaryText: i18n.t(
        'language-suggest.cu-language.text',
        'Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic'
      ),
    },
    { key: 'cv', primaryText: i18n.t('language-suggest.cv-language.text', 'Chuvash') },
    { key: 'kw', primaryText: i18n.t('language-suggest.kw-language.text', 'Cornish') },
    { key: 'co', primaryText: i18n.t('language-suggest.co-language.text', 'Corsican') },
    { key: 'cr', primaryText: i18n.t('language-suggest.cr-language.text', 'Cree') },
    { key: 'hr', primaryText: i18n.t('language-suggest.hr-language.text', 'Croatian') },
    { key: 'cs', primaryText: i18n.t('language-suggest.cs-language.text', 'Czech') },
    { key: 'da', primaryText: i18n.t('language-suggest.da-language.text', 'Danish') },
    { key: 'dv', primaryText: i18n.t('language-suggest.dv-language.text', 'Divehi; Dhivehi; Maldivian') },
    { key: 'nl', primaryText: i18n.t('language-suggest.nl-language.text', 'Dutch; Flemish') },
    { key: 'nn', primaryText: i18n.t('language-suggest.nn-language.text', 'Norwegian Nynorsk; Nynorsk, Norwegian') },
    { key: 'dz', primaryText: i18n.t('language-suggest.dz-language.text', 'Dzongkha') },
    { key: 'en', primaryText: i18n.t('language-suggest.en-language.text', 'English') },
    { key: 'eo', primaryText: i18n.t('language-suggest.eo-language.text', 'Esperanto') },
    { key: 'et', primaryText: i18n.t('language-suggest.et-language.text', 'Estonian') },
    { key: 'ee', primaryText: i18n.t('language-suggest.ee-language.text', 'Ewe') },
    { key: 'fo', primaryText: i18n.t('language-suggest.fo-language.text', 'Faroese') },
    { key: 'fj', primaryText: i18n.t('language-suggest.fj-language.text', 'Fijian') },
    { key: 'fil', primaryText: i18n.t('language-suggest.fil-language.text', 'Filipino') },
    { key: 'fi', primaryText: i18n.t('language-suggest.fi-language.text', 'Finnish') },
    { key: 'fr', primaryText: i18n.t('language-suggest.fr-language.text', 'French') },
    { key: 'ff', primaryText: i18n.t('language-suggest.ff-language.text', 'Fulah') },
    { key: 'gd', primaryText: i18n.t('language-suggest.gd-language.text', 'Gaelic; Scottish Gaelic') },
    { key: 'gl', primaryText: i18n.t('language-suggest.gl-language.text', 'Galician') },
    { key: 'lg', primaryText: i18n.t('language-suggest.lg-language.text', 'Ganda') },
    { key: 'ka', primaryText: i18n.t('language-suggest.ka-language.text', 'Georgian') },
    { key: 'de', primaryText: i18n.t('language-suggest.de-language.text', 'German') },
    { key: 'el', primaryText: i18n.t('language-suggest.el-language.text', 'Greek, Modern (1453-)') },
    { key: 'gn', primaryText: i18n.t('language-suggest.gn-language.text', 'Guarani') },
    { key: 'gu', primaryText: i18n.t('language-suggest.gu-language.text', 'Gujarati') },
    { key: 'ht', primaryText: i18n.t('language-suggest.ht-language.text', 'Haitian; Haitian Creole') },
    { key: 'ha', primaryText: i18n.t('language-suggest.ha-language.text', 'Hausa') },
    { key: 'he', primaryText: i18n.t('language-suggest.he-language.text', 'Hebrew') },
    { key: 'hz', primaryText: i18n.t('language-suggest.hz-language.text', 'Herero') },
    { key: 'hil', primaryText: i18n.t('language-suggest.hil-language.text', 'Hiligaynon') },
    { key: 'hi', primaryText: i18n.t('language-suggest.hi-language.text', 'Hindi') },
    { key: 'ho', primaryText: i18n.t('language-suggest.ho-language.text', 'Hiri Motu') },
    { key: 'hu', primaryText: i18n.t('language-suggest.hu-language.text', 'Hungarian') },
    { key: 'is', primaryText: i18n.t('language-suggest.is-language.text', 'Icelandic') },
    { key: 'io', primaryText: i18n.t('language-suggest.io-language.text', 'Ido') },
    { key: 'ig', primaryText: i18n.t('language-suggest.ig-language.text', 'Igbo') },
    { key: 'ilo', primaryText: i18n.t('language-suggest.ilo-language.text', 'Ilocano') },
    { key: 'id', primaryText: i18n.t('language-suggest.id-language.text', 'Indonesian') },
    {
      key: 'ia',
      primaryText: i18n.t(
        'language-suggest.ia-language.text',
        'Interlingua (International Auxiliary Language Association)'
      ),
    },
    { key: 'ie', primaryText: i18n.t('language-suggest.ie-language.text', 'Interlingue; Occidental') },
    { key: 'iu', primaryText: i18n.t('language-suggest.iu-language.text', 'Inuktitut') },
    { key: 'ik', primaryText: i18n.t('language-suggest.ik-language.text', 'Inupiaq') },
    { key: 'ga', primaryText: i18n.t('language-suggest.ga-language.text', 'Irish') },
    { key: 'it', primaryText: i18n.t('language-suggest.it-language.text', 'Italian') },
    { key: 'ja', primaryText: i18n.t('language-suggest.ja-language.text', 'Japanese') },
    { key: 'ja-kana', primaryText: i18n.t('language-suggest.ja-kana-language.text', 'Japanese(Katakana)') },
    { key: 'jv', primaryText: i18n.t('language-suggest.jv-language.text', 'Javanese') },
    {
      key: 'zh-Latn-x-jyutping',
      primaryText: i18n.t('language-suggest.zh-Latn-x-jyutping-language.text', 'Jyutping'),
    },
    { key: 'kbd', primaryText: i18n.t('language-suggest.kbd-language.text', 'Kabardian') },
    { key: 'kl', primaryText: i18n.t('language-suggest.kl-language.text', 'Kalaallisut; Greenlandic') },
    { key: 'pam', primaryText: i18n.t('language-suggest.pam-language.text', 'Kapampangan, Pampanga') },
    { key: 'kn', primaryText: i18n.t('language-suggest.kn-language.text', 'Kannada') },
    { key: 'kr', primaryText: i18n.t('language-suggest.kr-language.text', 'Kanuri') },
    { key: 'kaa', primaryText: i18n.t('language-suggest.kaa-language.text', 'Kara-Kalpak') },
    { key: 'krc', primaryText: i18n.t('language-suggest.krc-language.text', 'Karachay-Balkar') },
    { key: 'krl', primaryText: i18n.t('language-suggest.krl-language.text', 'Karelian') },
    { key: 'ks', primaryText: i18n.t('language-suggest.ks-language.text', 'Kashmiri') },
    { key: 'csb', primaryText: i18n.t('language-suggest.csb-language.text', 'Kashubian') },
    { key: 'kk', primaryText: i18n.t('language-suggest.kk-language.text', 'Kazakh') },
    { key: 'kjh', primaryText: i18n.t('language-suggest.kjh-language.text', 'Khakas') },
    { key: 'ki', primaryText: i18n.t('language-suggest.ki-language.text', 'Kikuyu; Gikuyu') },
    { key: 'rw', primaryText: i18n.t('language-suggest.rw-language.text', 'Kinyarwanda') },
    { key: 'ky', primaryText: i18n.t('language-suggest.ky-language.text', 'Kirghiz; Kyrgyz') },
    { key: 'kv', primaryText: i18n.t('language-suggest.kv-language.text', 'Komi') },
    { key: 'kg', primaryText: i18n.t('language-suggest.kg-language.text', 'Kongo') },
    { key: 'ko', primaryText: i18n.t('language-suggest.ko-language.text', 'Korean') },
    { key: 'ko-Hang', primaryText: i18n.t('language-suggest.ko-Hang-language.text', 'Korean(Hangeul)') },
    { key: 'ko-Hani', primaryText: i18n.t('language-suggest.ko-Hani-language.text', 'Korean(Hanja)') },
    { key: 'ko-Latn', primaryText: i18n.t('language-suggest.ko-Latn-language.text', 'Korean(Romanization)') },
    { key: 'kj', primaryText: i18n.t('language-suggest.kj-language.text', 'Kuanyama; Kwanyama') },
    { key: 'kum', primaryText: i18n.t('language-suggest.kum-language.text', 'Kumyk') },
    { key: 'ku', primaryText: i18n.t('language-suggest.ku-language.text', 'Kurdish') },
    { key: 'lld', primaryText: i18n.t('language-suggest.lld-language.text', 'Ladin') },
    { key: 'lap', primaryText: i18n.t('language-suggest.lap-language.text', 'Laka (Chad)') },
    { key: 'lo', primaryText: i18n.t('language-suggest.lo-language.text', 'Lao') },
    { key: 'la', primaryText: i18n.t('language-suggest.la-language.text', 'Latin') },
    { key: 'lv', primaryText: i18n.t('language-suggest.lv-language.text', 'Latvian') },
    { key: 'li', primaryText: i18n.t('language-suggest.li-language.text', 'Limburgan; Limburger; Limburgish') },
    { key: 'ln', primaryText: i18n.t('language-suggest.ln-language.text', 'Lingala') },
    { key: 'lt', primaryText: i18n.t('language-suggest.lt-language.text', 'Lithuanian') },
    { key: 'nds', primaryText: i18n.t('language-suggest.nds-language.text', 'Low German, Low Saxon') },
    { key: 'lu', primaryText: i18n.t('language-suggest.lu-language.text', 'Luba-Katanga') },
    { key: 'lb', primaryText: i18n.t('language-suggest.lb-language.text', 'Luxembourgish; Letzeburgesch') },
    { key: 'mk', primaryText: i18n.t('language-suggest.mk-language.text', 'Macedonian') },
    { key: 'mg', primaryText: i18n.t('language-suggest.mg-language.text', 'Malagasy') },
    { key: 'ms', primaryText: i18n.t('language-suggest.ms-language.text', 'Malay') },
    { key: 'ml', primaryText: i18n.t('language-suggest.ml-language.text', 'Malayalam') },
    { key: 'mt', primaryText: i18n.t('language-suggest.mt-language.text', 'Maltese') },
    { key: 'gv', primaryText: i18n.t('language-suggest.gv-language.text', 'Manx') },
    { key: 'mi', primaryText: i18n.t('language-suggest.mi-language.text', 'Maori') },
    { key: 'mr', primaryText: i18n.t('language-suggest.mr-language.text', 'Marathi') },
    { key: 'mh', primaryText: i18n.t('language-suggest.mh-language.text', 'Marshallese') },
    { key: 'mn', primaryText: i18n.t('language-suggest.mn-language.text', 'Mongolian') },
    { key: 'na', primaryText: i18n.t('language-suggest.na-language.text', 'Nauru') },
    { key: 'nb', primaryText: i18n.t('language-suggest.nb-language.text', 'Bokmål, Norwegian; Norwegian Bokmål') },
    { key: 'nv', primaryText: i18n.t('language-suggest.nv-language.text', 'Navajo; Navaho') },
    { key: 'nd', primaryText: i18n.t('language-suggest.nd-language.text', 'Ndebele, North; North Ndebele') },
    { key: 'nr', primaryText: i18n.t('language-suggest.nr-language.text', 'Ndebele, South; South Ndebele') },
    { key: 'ng', primaryText: i18n.t('language-suggest.ng-language.text', 'Ndonga') },
    { key: 'ne', primaryText: i18n.t('language-suggest.ne-language.text', 'Nepali') },
    { key: 'se', primaryText: i18n.t('language-suggest.se-language.text', 'Northern Sami') },
    { key: 'no', primaryText: i18n.t('language-suggest.no-language.text', 'Norwegian') },
    { key: 'oc', primaryText: i18n.t('language-suggest.oc-language.text', 'Occitan (post 1500)') },
    { key: 'oj', primaryText: i18n.t('language-suggest.oj-language.text', 'Ojibwa') },
    { key: 'or', primaryText: i18n.t('language-suggest.or-language.text', 'Oriya') },
    { key: 'om', primaryText: i18n.t('language-suggest.om-language.text', 'Oromo') },
    { key: 'os', primaryText: i18n.t('language-suggest.os-language.text', 'Ossetian; Ossetic') },
    { key: 'pag', primaryText: i18n.t('language-suggest.pag-language.text', 'Pangasinan') },
    { key: 'pi', primaryText: i18n.t('language-suggest.pi-language.text', 'Pali') },
    { key: 'pa', primaryText: i18n.t('language-suggest.pa-language.text', 'Panjabi; Punjabi') },
    { key: 'fa', primaryText: i18n.t('language-suggest.fa-language.text', 'Persian') },
    { key: 'zh-Latn-x-pinyin', primaryText: i18n.t('language-suggest.zh-Latn-x-pinyin-language.text', 'Pinyin') },
    { key: 'pl', primaryText: i18n.t('language-suggest.pl-language.text', 'Polish') },
    { key: 'pt', primaryText: i18n.t('language-suggest.pt-language.text', 'Portuguese') },
    { key: 'ps', primaryText: i18n.t('language-suggest.ps-language.text', 'Pushto; Pashto') },
    { key: 'qu', primaryText: i18n.t('language-suggest.qu-language.text', 'Quechua') },
    { key: 'ro', primaryText: i18n.t('language-suggest.ro-language.text', 'Romanian; Moldavian; Moldovan') },
    { key: 'rm', primaryText: i18n.t('language-suggest.rm-language.text', 'Romansh') },
    { key: 'rn', primaryText: i18n.t('language-suggest.rn-language.text', 'Rundi') },
    { key: 'ru', primaryText: i18n.t('language-suggest.ru-language.text', 'Russian') },
    { key: 'sm', primaryText: i18n.t('language-suggest.sm-language.text', 'Samoan') },
    { key: 'smi', primaryText: i18n.t('language-suggest.smi-language.text', 'Sami Languages') },
    { key: 'sg', primaryText: i18n.t('language-suggest.sg-language.text', 'Sango') },
    { key: 'sa', primaryText: i18n.t('language-suggest.sa-language.text', 'Sanskrit') },
    { key: 'sc', primaryText: i18n.t('language-suggest.sc-language.text', 'Sardinian') },
    { key: 'sr', primaryText: i18n.t('language-suggest.sr-language.text', 'Serbian') },
    { key: 'sn', primaryText: i18n.t('language-suggest.sn-language.text', 'Shona') },
    {
      key: 'ii',
      primaryText: i18n.t('language-suggest.ii-language.text', 'Sichuan Yi; Nuosu; (Chinese - Yi Ethnic)'),
    },
    { key: 'scn', primaryText: i18n.t('language-suggest.scn-language.text', 'Sicilian') },
    { key: 'sd', primaryText: i18n.t('language-suggest.sd-language.text', 'Sindhi') },
    { key: 'si', primaryText: i18n.t('language-suggest.si-language.text', 'Sinhala; Sinhalese') },
    { key: 'sk', primaryText: i18n.t('language-suggest.sk-language.text', 'Slovak') },
    { key: 'sl', primaryText: i18n.t('language-suggest.sl-language.text', 'Slovenian') },
    { key: 'so', primaryText: i18n.t('language-suggest.so-language.text', 'Somali') },
    { key: 'st', primaryText: i18n.t('language-suggest.st-language.text', 'Sotho, Southern') },

    // Use 'es' for Spanish and 'es-ES' for Castilian (see https://www.techonthenet.com/js/language_tags.php)
    { key: 'es', primaryText: i18n.t('language-suggest.es-language.text', 'Spanish') },
    { key: 'es-ES', primaryText: i18n.t('language-suggest.es-ES-language.text', 'Spanish; Castilian') },
    { key: 'su', primaryText: i18n.t('language-suggest.su-language.text', 'Sundanese') },
    { key: 'sw', primaryText: i18n.t('language-suggest.sw-language.text', 'Swahili') },
    { key: 'ss', primaryText: i18n.t('language-suggest.ss-language.text', 'Swati') },
    { key: 'sv', primaryText: i18n.t('language-suggest.sv-language.text', 'Swedish') },
    { key: 'tl', primaryText: i18n.t('language-suggest.tl-language.text', 'Tagalog') },
    { key: 'ty', primaryText: i18n.t('language-suggest.ty-language.text', 'Tahitian') },
    { key: 'tg', primaryText: i18n.t('language-suggest.tg-language.text', 'Tajik') },
    { key: 'ta', primaryText: i18n.t('language-suggest.ta-language.text', 'Tamil') },
    { key: 'tt', primaryText: i18n.t('language-suggest.tt-language.text', 'Tatar') },
    { key: 'te', primaryText: i18n.t('language-suggest.te-language.text', 'Telugu') },
    { key: 'th', primaryText: i18n.t('language-suggest.th-language.text', 'Thai') },
    { key: 'bo', primaryText: i18n.t('language-suggest.bo-language.text', 'Tibetan') },
    { key: 'ti', primaryText: i18n.t('language-suggest.ti-language.text', 'Tigrinya') },
    { key: 'to', primaryText: i18n.t('language-suggest.to-language.text', 'Tonga (Tonga Islands)') },
    { key: 'ts', primaryText: i18n.t('language-suggest.ts-language.text', 'Tsonga') },
    { key: 'tn', primaryText: i18n.t('language-suggest.tn-language.text', 'Tswana') },
    { key: 'tr', primaryText: i18n.t('language-suggest.tr-language.text', 'Turkish') },
    { key: 'tk', primaryText: i18n.t('language-suggest.tk-language.text', 'Turkmen') },
    { key: 'tyv', primaryText: i18n.t('language-suggest.tyv-language.text', 'Tuvinian') },
    { key: 'tw', primaryText: i18n.t('language-suggest.tw-language.text', 'Twi') },
    { key: 'ug', primaryText: i18n.t('language-suggest.ug-language.text', 'Uighur; Uyghur') },
    { key: 'uk', primaryText: i18n.t('language-suggest.uk-language.text', 'Ukrainian') },
    { key: 'ur', primaryText: i18n.t('language-suggest.ur-language.text', 'Urdu') },
    { key: 'uz', primaryText: i18n.t('language-suggest.uz-language.text', 'Uzbek') },
    { key: 've', primaryText: i18n.t('language-suggest.ve-language.text', 'Venda') },
    { key: 'vi', primaryText: i18n.t('language-suggest.vi-language.text', 'Vietnamese') },
    { key: 'vo', primaryText: i18n.t('language-suggest.vo-language.text', 'Volapük') },
    { key: 'wa', primaryText: i18n.t('language-suggest.wa-language.text', 'Walloon') },
    { key: 'war', primaryText: i18n.t('language-suggest.war-language.text', 'Waray (Philippines)') },
    { key: 'cy', primaryText: i18n.t('language-suggest.cy-language.text', 'Welsh') },
    { key: 'fy', primaryText: i18n.t('language-suggest.fy-language.text', 'Western Frisian') },
    { key: 'wo', primaryText: i18n.t('language-suggest.wo-language.text', 'Wolof') },
    { key: 'xh', primaryText: i18n.t('language-suggest.xh-language.text', 'Xhosa') },
    { key: 'yi', primaryText: i18n.t('language-suggest.yi-language.text', 'Yiddish') },
    { key: 'yo', primaryText: i18n.t('language-suggest.yo-language.text', 'Yoruba') },
    {
      key: 'zza',
      primaryText: i18n.t(
        'language-suggest.zza-language.text',
        'Zaza, Dimili, Dimli (macrolanguage), Kirdki, Kirmanjki (macrolanguage), Zazaki'
      ),
    },
    { key: 'za', primaryText: i18n.t('language-suggest.za-language.text', 'Zhuang; Chuang') },
    { key: 'zu', primaryText: i18n.t('language-suggest.zu-language.text', 'Zulu') },
  ].map((obj) => {
    obj.code = obj.key
    return obj
  })
}
let supportedLanguages = getLanguages()
i18n.on('languageChanged', () => {
  supportedLanguages = getLanguages()
})

export function getLanguage(initialLocale = i18n.language || 'en', includeLocaleInPrimaryText) {
  const foundItem = supportedLanguages.find((lang) => lang.key === initialLocale)
  if (foundItem) {
    return includeLocaleInPrimaryText
      ? { ...foundItem, primaryText: `${foundItem.primaryText} (${foundItem.code})` }
      : foundItem
  }
  // if match not found, return placeholder object instead of undefined
  return { primaryText: initialLocale, key: initialLocale, code: initialLocale }
}
